import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { CommonModule, DOCUMENT } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { Title } from '@angular/platform-browser';
import { SeoService } from '../../services/seo.service';

@Component({
  selector: 'app-impressum',
  standalone: true,
  imports: [CommonModule, MatCardModule],
  templateUrl: './impressum.component.html',
  styleUrl: './impressum.component.scss',
})
export class ImpressumComponent implements OnInit, OnDestroy {
  private readonly pageTitle = 'Impressum | Rast-WC.de';
  private readonly pageDescription =
    'Impressum von Rast-WC.de: Anbieterkennzeichnung, Kontakt, Haftungsausschluss und rechtliche Hinweise.';

  constructor(
    private title: Title,
    private seo: SeoService,
    @Inject(DOCUMENT) private doc: Document,
  ) {}

  ngOnInit(): void {
    this.title.setTitle(this.pageTitle);
    this.seo.updateMetaDescription(this.pageDescription);
    this.setCanonical(this.doc.location?.origin + '/impressum');
  }

  ngOnDestroy(): void {
    this.seo.resetMetaDescription();
  }

  private setCanonical(href: string | undefined) {
    if (!href) return;
    let link: HTMLLinkElement | null = this.doc.querySelector('link[rel="canonical"]');
    if (!link) {
      link = this.doc.createElement('link');
      link.setAttribute('rel', 'canonical');
      this.doc.head.appendChild(link);
    }
    link.setAttribute('href', href);
  }
}
